export default {
  HOME: { path: '/' },
  LOGIN: { path: '/login' },
  EMPLOYEES: { path: '/employees' },
  SINGLE_EMPLOYEE: { path: '/employees/:id' },
  NOT_FOUND: { path: '/page-not-found' },
};
